import { Heading } from "@mittwald/flow-remote-react-components";
import { useAppInstallationPHPStatistics } from "../hooks/useAppInstallationPHPStatistics.ts";
import { ProgressBar } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { Header } from "@mittwald/flow-remote-react-components";
import {
  ContextualHelp,
  ContextualHelpTrigger,
} from "@mittwald/flow-remote-react-components";
import { Button } from "@mittwald/flow-remote-react-components";
import { Link } from "@mittwald/flow-remote-react-components";
import { Modal } from "@mittwald/flow-remote-react-components";
import { IconDelete } from "@mittwald/flow-remote-react-components";
import { Content } from "@mittwald/flow-remote-react-components";
import { Section } from "@mittwald/flow-remote-react-components";
import { ActionGroup } from "@mittwald/flow-remote-react-components";
import { Action } from "@mittwald/flow-remote-react-components";
import { Label } from "@mittwald/flow-remote-react-components";
import { Flex } from "@mittwald/flow-remote-react-components";
import { useClearAPCu } from "../hooks/useClearAPCu.ts";
export const APCuStats = (props: {
  projectId: string;
  appInstallationId: string;
}) => {
  const phpStats = useAppInstallationPHPStatistics(
    props.projectId,
    props.appInstallationId,
  );

  const clearAPCuMutation = useClearAPCu(
    props.projectId,
    props.appInstallationId,
  );

  return (
    <>
      <Header>
        <Heading level={3}>
          APCu
          <ContextualHelpTrigger>
            <Button />
            <ContextualHelp>
              <Heading>APCu</Heading>
              <Text>
                APCu ist ein In-Memory-Key-Value-Store für PHP. Die Schlüssel
                sind vom Typ String, während die Werte beliebige PHP-Variablen
                sein können.
              </Text>
              <Link
                href="https://www.php.net/manual/de/book.apcu.php"
                target="_blank"
              >
                Mehr erfahren
              </Link>
            </ContextualHelp>
          </ContextualHelpTrigger>
        </Heading>
        <Action onAction={() => clearAPCuMutation.mutateAsync()}>
          <Modal size="s" slot="actionConfirm">
            <Heading>
              <Flex
                elementType="span"
                direction="row"
                align="center"
                justify="center"
                gap="s"
              >
                <IconDelete />
                Möchtest du den APCu wirklich leeren?
              </Flex>
            </Heading>
            <Content>
              <Section>
                <Text>
                  Das Leeren des APCu sorgt initial für einen verlängerten
                  Seitenaufruf.
                </Text>
              </Section>
            </Content>
            <ActionGroup>
              <Button color="danger">APCu leeren</Button>
              <Button variant="soft" color="secondary">
                Abbrechen
              </Button>
            </ActionGroup>
          </Modal>
          <Button color="danger" variant="soft">
            APCu leeren
          </Button>
        </Action>
      </Header>
      <ProgressBar
        value={phpStats.data.apcu?.usage ?? 0}
        maxValue={phpStats.data.apcu?.size ?? 0}
        showMaxValue
        formatOptions={{ style: "unit", unit: "megabyte" }}
      >
        <Label>Aktuelle APCu-Auslastung</Label>
      </ProgressBar>
    </>
  );
};
